export { default } from './TabWithImage.js'
export type { TabWithImageProps, TabWithImageDataItem } from './types.js'
